import { render, staticRenderFns } from "./BtnEnviarRequisicao.vue?vue&type=template&id=1b01ff57&"
import script from "./BtnEnviarRequisicao.vue?vue&type=script&lang=js&"
export * from "./BtnEnviarRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports